import React from "react";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";

import { Helmet } from "react-helmet";

// Shared assets reused from Loyalty Management page
import DataConsultantsIcon from "../assets/images/icons/dataConsultants.png";
import inTheMartechIndustryIcon from "../assets/images/icons/inTheMartechIndustry.png";
import expertsIcon from "../assets/images/icons/experts.png";
import topPartnersIcon from "../assets/images/icons/topPartners.png";
import MartechSMEsIcon from "../assets/images/icons/Martech-SMEs.png";
import MarketingCloudStrategyAndRoadmapIcon from "../assets/images/icons/Marketing-Cloud-Strategy-And-Roadmap.png";
import ABTestingIcon from "../assets/images/icons/ABTesting.png";
import MultiChannelJourneyOrchestrationIcon from "../assets/images/icons/Multi-Channel-Journey-Orchestration.png";
import AdvancedSegmentationAndPersonalizationIcon from "../assets/images/icons/AdvancedSegmentationAndPersonalization.png";
import ReportingAndAnalysisIcon from "../assets/images/icons/ReportingAndAnalysis.png";
import layerOne from "../assets/images/layers/GroupLeft.png";
import layerTwo from "../assets/images/layers/GroupRight.png";
import tableauBannerMobile from "../assets/images/banner/tableauMobile.jpg";

const Tableau = () => {
  return (
    <>
      <Helmet>
        <title>Tableau Consulting Services Pune | AI Data Analytics</title>

        <meta
          name="description"
          content="Unlock insights with Tableau analytics. AI-powered dashboards, BI & data visualization services in Pune, India."
        />

        <meta
          name="keywords"
          content="Tableau Pune, Data Visualization India, BI Analytics Services Pune, AI Data Analytics"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Tableau Consulting Services Pune | AI Data Analytics"
        />
        <meta
          property="og:description"
          content="AI-powered dashboards, BI analytics & data visualization services in Pune."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.comsensetechnologies.com/tableau"
        />
      </Helmet>

      <header className="masthead subPageHead data-cloud-header tableauBanner">
        <div className="container">
          <Row className="justify-content-start">
            <Col xl={7} lg={5}>
              <h1 className="masthead-heading text-white mt-4 mb-4">
                Salesforce{" "}
                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                  {" "}
                  Tableau
                </span>{" "}
                Services
              </h1>
            </Col>
            <Col lg={12} className="mt-5 mt-lg-0 d-block d-lg-none">
              <Image className="w-100" src={tableauBannerMobile} />
            </Col>
          </Row>
        </div>
      </header>

      <section className="bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  Unlock Insight at Every Touchpoint with{" "}
                  <span className="bordered-text">Tableau</span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-center justify-content-center">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="mt-0 fs-5 fw-normal ls-0">
                Turn scattered data into clear stories your teams can act on –
                across marketing, sales, and service.
              </p>
              <p className="mt-0 fs-5 fw-normal ls-0">
                At Comsense, we combine Tableau analytics, Salesforce, and
                modern data platforms to help you see your business clearly,
                move faster, and make decisions with confidence. From executive
                dashboards to self-service analytics, we design Tableau
                solutions that are simple to adopt, yet powerful enough to
                support enterprise-grade decision-making.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-80 pb-80 bg-white">
        <Container>
          <Row className="align-items-center mt-4 justify-content-center testimonials-area position-relative">
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={MartechSMEsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">50+</h5>
                <p className="fw-500 fs-6">Tableau Dashboards Delivered</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={DataConsultantsIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">40+</h5>
                <p className="fw-500 fs-6">Analytics & BI Consultants</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={inTheMartechIndustryIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">10+ Years</h5>
                <p className="fw-500 fs-6">in the Martech Industry</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={expertsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Multi Industry</h5>
                <p className="fw-500 fs-6">BI & Reporting Expertise</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={topPartnersIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Top Partners</h5>
                <p className="fw-500 fs-6">of Salesforce</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-70 pb-70 bg-E2F1FE">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={11}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  How we help you succeed with{" "}
                  <span className="bordered-text"> Tableau</span>?
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4 justify-content-start position-relative">
            <Col lg={12}>
              <Row>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4 d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MarketingCloudStrategyAndRoadmapIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Clear, Trusted KPIs
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Establish a single source of truth across marketing,
                        sales, and service teams.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ABTestingIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Faster Decision-Making
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Enable near real-time insights through live,
                        performance-optimized dashboards.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MultiChannelJourneyOrchestrationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        High Analytics Adoption
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Drive self-service analytics with intuitive views for
                        non-technical users.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={AdvancedSegmentationAndPersonalizationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Data-Led Optimization
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Optimize campaigns and channels using evidence, not
                        assumptions.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ReportingAndAnalysisIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Improved Customer Experience
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Enhance CX using journey-level visibility and behavioral
                        insights.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ReportingAndAnalysisIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Reduced Reporting Overhead
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Automate refreshes with governed datasets to minimize
                        manual reporting effort.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section bg-white pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={10} className="offset-lg-1">
              <div className="text-center">
                <span className="d-block fw-500 ls-0 mb-1 fs-15 text-252B42">
                  Every engagement follows a simple formula
                </span>
                <h2 className="section-heading text-center mb-0 section-heading-center fw-700 fs-40">
                  We listen. We plan. We execute.{" "}
                </h2>
                <p className="mb-0">
                  Most organizations already have data – the challenge is
                  turning it into trusted, usable insight.
                </p>
                <p>
                  Comsense helps you connect Tableau with your Salesforce
                  ecosystem and marketing stack so every team – from CXOs to
                  frontline agents – has timely, relevant views of performance.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="align-items-stretch mt-4 justify-content-center">
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Strategy & Program Design
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    We assess your analytics maturity, business goals, and
                    reporting needs to define a scalable Tableau roadmap.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Tableau Implementation
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Build high-performance dashboards and data models that
                    deliver trusted, real-time business intelligence.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Managed Analytics Services
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    Ensure continuous optimization, performance monitoring,
                    enhancements, and long-term Tableau adoption.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Data & Reporting Audit
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Evaluate dashboard accuracy, data quality, governance, and
                    performance to eliminate reporting inefficiencies.{" "}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section bg-E2F1FE z-0 overflow-hidden pt-70 pb-70 position-relative">
        <Image
          className="position-absolute z-n1 w-250 bg-cover h-auto position-absolute start-0 bottom-0"
          src={layerOne}
        />
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg={7}>
              <div className="text-center">
                <h2
                  className="text-252B42 fw-700 fs-26"
                  style={{ lineHeight: "normal" }}
                >
                  Let Us Help You See More in Your Data
                </h2>
                <p className="ls-minus036 fs-13">
                  Whether you are just starting with Tableau or looking to
                  modernize your existing analytics, Comsense can help you
                  design a Tableau practice that scales with your business.
                </p>
                <Nav.Link
                  className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  as={Link}
                  to="../contact"
                >
                  Connect with our team to discuss your Tableau roadmap
                </Nav.Link>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          className="position-absolute z-n1 w-250 bg-cover h-auto position-absolute end-0 top-0 opacity-25"
          src={layerTwo}
        />
      </section>
    </>
  );
};

export default Tableau;
